import { Link } from "react-router-dom";
import SeoHead from "../components/SeoHead";
import { SITE } from "../lib/site";

export default function NotFound() {
  return (
    <div className="container-x py-32 text-center" data-testid="not-found-page">
      <SeoHead title="Page introuvable | Termite Bordeaux" noindex canonical={SITE.url + "/404"} />
      <div className="eyebrow mb-3">404</div>
      <h1 className="font-serif text-5xl text-gray-900 mb-4">Page introuvable</h1>
      <p className="text-gray-700 mb-8">Cette adresse n'existe pas — ou plus.</p>
      <Link to="/" className="btn-primary" data-testid="back-home">Retour à l'accueil</Link>
    </div>
  );
}
